"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TonPriceManagerContractAdapter = void 0;
class TonPriceManagerContractAdapter {
    constructor(contract) {
        this.contract = contract;
    }
    async sendDeploy() {
        return this.contract.sendDeploy();
    }
    async getPricesFromPayload(paramsProvider) {
        return this.contract.getPrices(paramsProvider);
    }
    async writePricesFromPayloadToContract(paramsProvider) {
        await this.contract.sendWritePrices(paramsProvider);
        return "";
    }
    async readPricesFromContract(paramsProvider) {
        return this.contract.getReadPrices(paramsProvider);
    }
    async readTimestampFromContract() {
        return this.contract.getReadTimestamp();
    }
}
exports.TonPriceManagerContractAdapter = TonPriceManagerContractAdapter;
//# sourceMappingURL=TonPriceManagerContractAdapter.js.map